// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const nino: CountryValidator<"GB"> = createValidator(
  "gb.nino",
  80,
);

export default nino;
export const compact = nino.compact;
export const format = nino.format;
export const validate = nino.validate;
export const generate = (): string =>
  nino.generate?.() ??
  (() => {
    throw new Error(
      "Validator gb.nino cannot generate values",
    );
  })();
